import React, { createContext, useContext, useState } from "react";

const AgentChatContext = createContext(null);

// Backs AgentChat's conversation state via React Context instead of Redux
// (deprecated in this project — see src/store/index.js) and instead of local
// component state, because this app's router (libs/router.js) renders each
// route's `layout` inside the matched <Route>, not hoisted above the
// <Switch> — so SiteLayout (and AgentChat within it) unmounts and remounts
// on every navigation. Local state would be lost every time the agent (or
// the user) navigates anywhere. Mounting this provider above the router in
// App.js keeps the state alive across those remounts.
export function AgentChatProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  // TEMP DEBUG: running token/cost total for this conversation.
  const [usageStats, setUsageStats] = useState({ tokens: 0, cost: 0 });
  // TEMP DEBUG: per-turn token/cost breakdown (incl. per-iteration detail for
  // turns that resolved a navigate_to_company_search call) — see
  // components/AgentChat/AgentChatDebugPanel.component.js.
  const [debugLog, setDebugLog] = useState([]);
  const [debugOpen, setDebugOpen] = useState(false);

  return (
    <AgentChatContext.Provider
      value={{
        open,
        setOpen,
        messages,
        setMessages,
        usageStats,
        setUsageStats,
        debugLog,
        setDebugLog,
        debugOpen,
        setDebugOpen,
      }}
    >
      {children}
    </AgentChatContext.Provider>
  );
}

export function useAgentChatState() {
  const ctx = useContext(AgentChatContext);
  if (!ctx) {
    throw new Error("useAgentChatState must be used within an AgentChatProvider");
  }
  return ctx;
}
